import { apiPost } from 'tennders-stracture/libs/api'
import { useEffect, useState } from 'react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'

const perPage = 20

const useTransactionLog = (type = 'loads', shouldShowCommentsOnly = false) => {
  const { transaction } = useTransaction()
  const [page, setpage] = useState(1)
  const [logs, setlogs] = useState([])
  const [nomore, setnomore] = useState(false)
  const [loading, setloading] = useState(false)

  const handleResponse = (response, forceInit) => {
    if (!response) {
      return
    }
    if (response.length < perPage) {
      setnomore(true)
    }
    if (forceInit) {
      setlogs([...response])
    } else {
      setlogs([...logs, ...response])
    }
    setloading(false)
    setpage(forceInit ? 1 : page + 1)
  }

  const fetchLoadHistory = async (id, forceInit = false) => {
    if (nomore && !forceInit) {
      return
    }
    if (page === 0 || forceInit) {
      setloading(true)
    }
    const response = await apiPost(`transaction/logs/load/${id}`, {
      page: forceInit ? 0 : page,
      perPage
    })
    if (shouldShowCommentsOnly) {
      handleResponse(response?.filter((i) => i.action === 'COMMENTED'), forceInit)
    } else {
      handleResponse(response, forceInit)
    }
  }

  const fetchTruckHistory = async (id, forceInit = false) => {
    if (nomore && !forceInit) {
      return
    }
    if (page === 0 || forceInit) {
      setloading(true)
    }
    const response = await apiPost(`transaction/logs/truck/${id}`, {
      page: forceInit ? 0 : page,
      perPage
    })
    if (shouldShowCommentsOnly) {
      handleResponse(response?.filter((i) => i.action === 'COMMENTED'), forceInit)
    } else {
      handleResponse(response, forceInit)
    }
  }

  const fetchLoadAndTruckHistory = async (id, forceInit = false) => {
    if (nomore && !forceInit) {
      return
    }
    if (page === 0 || forceInit) {
      setloading(true)
    }
    const response = await apiPost(`transaction/logs/loadAndTruck/${id}`, {
      page: forceInit ? 0 : page,
      perPage
    })
    if (shouldShowCommentsOnly) {
      handleResponse(response?.filter((i) => i.action === 'COMMENTED'), forceInit)
    } else {
      handleResponse(response, forceInit)
    }
  }

  useEffect(() => {
    if (type === 'loads' && transaction.loadLogs?.length > 0) {
      const loadLogs = shouldShowCommentsOnly ? transaction?.loadLogs?.filter((l) => l.action === 'COMMENTED') : transaction?.loadLogs
      setlogs(loadLogs)
      setnomore(loadLogs.length < perPage)
    } else if (type === 'trucks' && transaction.truckLogs?.length > 0) {
      const truckLogs = shouldShowCommentsOnly ? transaction?.truckLogs?.filter((l) => l.action === 'COMMENTED') : transaction?.truckLogs
      setlogs(truckLogs)
      setnomore(truckLogs.length < perPage)
    }
  }, [transaction?.truckLogs, transaction?.loadLogs, type, shouldShowCommentsOnly])

  return {
    logs,
    fetchLoadHistory,
    fetchTruckHistory,
    nomore,
    fetchLoadAndTruckHistory,
    loading
  }
}

export default useTransactionLog
